import { useQuery } from '@tanstack/react-query';
import type { PaginatedList } from '../../../../../models/common/paginated-list.model';
import type { HistoryOfSchoolTaxesPaymentsDto } from '../../../../../models/taxes/school/history-of-school-taxes-payments.dto';
import apiRequest from '../../../../../services/apiWrapper';
import { SCHOOL_TAX_PAYMENT_HISTORY_URL } from '../../../../../utils/constants/urlConstants';

export async function fetchInstallmentsByStudent(
  studentId: string,
  startYear?: number
) {
  const params = new URLSearchParams({
    size: '9999',
    studentId,
  });

  if (startYear) {
    params.append('startYear', startYear.toString());
  }

  const response = await apiRequest.get<
    PaginatedList<HistoryOfSchoolTaxesPaymentsDto>
  >(`${SCHOOL_TAX_PAYMENT_HISTORY_URL}?${params.toString()}`);

  return response.data;
}

export function useGetInstallmentsByStudent(
  studentId: string,
  startYear?: number
) {
  return useQuery({
    queryKey: ['installments', studentId, startYear],
    queryFn: () => fetchInstallmentsByStudent(studentId, startYear),
    enabled: studentId !== '',
  });
}
